import React, { forwardRef, Ref } from 'react';
import { MetadataSettings } from './metadata-edit';
import { MetadataViewModel } from './metadata-models';

interface Props {
  model: MetadataViewModel;
}
export interface MetadataAddFormRef {
  submitAddMetadata: () => Promise<void>;
}
export const AddMetadata = forwardRef((props: Props, ref: Ref<MetadataAddFormRef>) => {
  const { model } = props;

  return (
    <div className="mk-add-metadata">
      <MetadataSettings ref={ref} model={model} />
    </div>
  );
});

AddMetadata.displayName = 'AddMetadata';
